import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import Pagination from "../common/pagination";
import SglContext from '../SglContext'
import { Link } from "react-router-dom";

function Entries(props) {
  // Declare all state variables
  const [showName, setShowName] = useState("");
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [sort, setSort] = useState({ sort_on: "number", sort_type: "asc" });
  const [totalRows, setTotalRows] = useState(0);
  const [paginationElement, setPaginationElement] = useState(null);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const Sgl = useContext(SglContext)

  const [currentShow, setCurrentShow] = useState(
    localStorage.getItem("show_id")
  );

  useEffect(() => {
    setCurrentShow(localStorage.getItem("show_id"));
  }, [props.currentShow]); // add props as dependencies

  useEffect(() => {
    setPaginationElement(React.createRef());
  }, []);

  useEffect(() => {
    axios
      .get(Sgl.nestApiUrl + "/entries", {
        params: {
          sort_on: sort.sort_on,
          sort_type: sort.sort_type,
          page: page,
          search_text: searchText,
          show_id: currentShow,
          customer_id: Sgl.company_id,
        },
      })
      .then((res) => {
        document.title = "Entry for " + res.data.show_name;
        Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath+ '/' + currentShow + '/entries/list/page/' + page);
        Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath+ '/' + currentShow + '/entries/list/page/' + page);
        setEntries(res.data.entries);
        setCurrentShow(res.data.show_id);
        setShowName(res.data.show_name);
        setTotalRows(res.data.total_entries);
        setLoading(false);
      });
  }, [sort, page, searchText, currentShow]);

  function onSearch(e) {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    e.persist();
    setSearchTimeout(
      setTimeout(() => {
        setSearchText(e.target.value);
        setPage(1);
      }, 700)
    );
  }

  function onSort(column) {
    if (sort.sort_on != column) {
      setSort({ sort_on: column, sort_type: "asc" });
    } else {
      setSort({
        sort_on: column,
        sort_type: sort.sort_type === "desc" ? "asc" : "desc",
      });
    }
    setPage(1);
  }

  function setArrow(column) {
    let className = "direction";
    if (sort.sort_on === column) {
      className += sort.sort_type === "asc" ? " asc" : " desc";
    }
    return className;
  }

  function onChangePage(page) {
    setPage(page);
  }

  if (loading) {
    return null;
  }

  return (
    <div className="section-to-print">
      <section className='search-area'>
        <table>
          <tbody>
            <tr>
              <td>
                <h2 className='sgl-h2'>Entries for {showName}</h2>
              </td>
            </tr>
            <tr>
              <td>
                <input
                  type='text'
                  className='input'
                  placeholder='Enter Number, Horse Name or Rider / Trainer / Owner to search'
                  onKeyUp={(e) => onSearch(e)}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
      <br />
      <div className='div-responsive'>
        <table className='table table-striped table-hover'>
          <tbody>
            <tr className='sgl-primary-header'>
              <th className="center-align"
                onClick={() => onSort("number")}>
                Entry <span className={setArrow("number")}></span>
              </th>
              <th style={{ min_width: "30px" }} onClick={() => onSort("horse")}>
                Horse <span className={setArrow("horse")}></span>
              </th>
              <th
                style={{ min_width: "30px" }}
                onClick={() => onSort("rider_list")}>
                Rider <span className={setArrow("rider_list")}></span>
              </th>
              <th
                style={{ min_width: "30px" }}
                onClick={() => onSort("trainer")}>
                Trainer <span className={setArrow("trainer")}></span>
              </th>
            </tr>
            {entries.map((entry, index) => {
              return (
                <tr key={index} className='sgl-anchor'>
                  <td className="center-align"><Link style={{float:'centre'}}to={"/entries/detail?eid=" + entry.entry_id + "&sid=" + currentShow}>{entry.number}</Link></td>
                  <td>
                    <Link to={
                      "/entries/detail?eid=" +
                      entry.entry_id +
                      "&sid=" +
                      currentShow
                    }>
                      {!entry.trainer_account ? entry.horse : "TRAINER ACCOUNT"}
                    </Link>
                  </td>
                  <td>
                    <Link to={
                      "/entries/detail?eid=" +
                      entry.entry_id +
                      "&sid=" +
                      currentShow
                    }>
                      {entry.rider_list}
                    </Link>
                  </td>
                  <td>
                    <Link to={
                      "/entries/detail?eid=" +
                      entry.entry_id +
                      "&sid=" +
                      currentShow
                    }>
                      {entry.trainer}
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Pagination
        items={totalRows}
        onChangePage={onChangePage}
        initialPage={page}
        ref={paginationElement}
      />
      <div>
        <span className='link_color'>
          <b>
            Showing {(page - 1) * 10 + 1} to {(page - 1) * 10 + entries.length}{" "}
            of {totalRows} results.
          </b>
        </span>
        <div className='copyright-text'>
            {" "}
            {process.env.REACT_APP_COPYRIGHT_TEXT}
          </div>
      </div>
    </div>
  );
}

export default Entries;
